import * as actions from './blog.actions';
import { EntityState, createEntityAdapter, Update } from '@ngrx/entity';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { BlogArticleModel } from '@smarttask-common/src/lib/models/Prismic/Blog/BlogArticleModel';

export const blogAdapter = createEntityAdapter<BlogArticleModel>({
    selectId: (x) => x.uid,
});
export interface BlogState extends EntityState<BlogArticleModel> {
    selected_blog_uid: string;
}

export const initialState: BlogState = blogAdapter.getInitialState({
    selected_blog_uid: undefined,
});

export function BlogReducers(state: BlogState = initialState, action: actions.BlogActions) {
    switch (action.type) {
        case actions.BlogActionTypes.UPDATE_SELECTED_ID:
            state = { ...state, selected_blog_uid: action.selected_blog_uid };
            return state;

        case actions.BlogActionTypes.ADD_BLOG:
            return blogAdapter.addOne(action.blog, state);

        case actions.BlogActionTypes.ADD_BLOGS:
            return blogAdapter.addMany(action.blogs, state);

        case actions.BlogActionTypes.UPSERT_BLOG:
            return blogAdapter.upsertOne(action.blog, state);

        case actions.BlogActionTypes.UPSERT_BLOGS:
            return blogAdapter.upsertMany(action.blogs, state);

        case actions.BlogActionTypes.UPDATE_BLOG:
            return blogAdapter.updateOne(action.blog, state);

        case actions.BlogActionTypes.UPDATE_BLOGS:
            return blogAdapter.updateMany(action.blogs, state);

        case actions.BlogActionTypes.DELETE_BLOG:
            // if(state.selectedBlogId == action.uid){
            //   state.selectedBlogId = undefined;
            // }
            return blogAdapter.removeOne(action.uid, state);

        case actions.BlogActionTypes.DELETE_BLOGS:
            // if(action.ids.indexOf(state.selectedBlogId) > -1){
            //   state.selectedBlogId = undefined;
            // }
            return blogAdapter.removeMany(action.uids, state);

        case actions.BlogActionTypes.DELETE_ALL_BLOGS:
            return blogAdapter.removeMany(action.uids, state);

        case actions.BlogActionTypes.DELETE_ALL:
            return blogAdapter.removeAll(state);

        default:
            return state;
    }
}

export const getBlogState = createFeatureSelector<BlogState>('blog');

export const { selectIds, selectEntities, selectAll, selectTotal } = blogAdapter.getSelectors(getBlogState);

const getSelectedBlogIdState = (state: BlogState) => {
    return state.selected_blog_uid;
};
export const getSelectedBlogId = createSelector(getBlogState, getSelectedBlogIdState);

export const getSelectedBlog = createSelector(getBlogState, (state: BlogState) => {
    if (state.selected_blog_uid == undefined) {
        return undefined;
    }
    return state.entities[state.selected_blog_uid];
});
